import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {
	CommunicationsMessageFiltersApp, CommunicationsMessageFiltersStore,
	OwnProps as CommunicationsMessageFiltersOwnProps
} from "./communications-message/app";
import {CallJs} from "../../lib/types";
import {createStore} from "redux";
import {withDefault} from "../../lib/utils";
import {reducer as communicationsMessageFiltersReducer, State as CommunicationsMessageFiltersState} from "./communications-message/reducers";
import {Message, OpenedStatus, SentStatus} from "./communications-message/data";

type CommunicationsMessageFiltersParams = {
	messages: Message[]
	selectedMessages: (string|number)[]
	sentStatus: SentStatus
	openedStatus: OpenedStatus
}

export const communicationsMessageFilters:CallJs<CommunicationsMessageFiltersParams> = (replace, params) => {
	const ownProps = (store: CommunicationsMessageFiltersStore): CommunicationsMessageFiltersOwnProps => ({
		store: store,
		messages: params.messages
	})

	const initialState: CommunicationsMessageFiltersState = {
		selectedMessages: params.selectedMessages,
		sentStatus: params.sentStatus,
		openedStatus: params.openedStatus
	}

	const div = document.createElement('div')
	replace(div)

	const store = createStore(withDefault(communicationsMessageFiltersReducer, initialState), initialState)
	ReactDOM.render(<CommunicationsMessageFiltersApp {...ownProps(store)}/>, div)
}



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/querybuilder-filters.tsx